import { useMemo } from 'react';

function useQuery() {
    const { search } = location;

    return useMemo(() => new URLSearchParams(search), [search]);
}

export default useQuery;
